import { fetchUserConfig } from './config'

const configApi = {
  fetchUserConfig: {
    key: 'FETCH_USER_CONFIG',
    fn: fetchUserConfig,
  },
}

export default configApi
